import $ from 'jquery'
// floatting head
import 'floatthead/dist/jquery.floatThead.min.js'
import 'bootstrap-datepicker'
// import 'lib/components/_bootstrap-timepicker.js'
import 'lib/components/_jquery-formset.js'
import * as Cookies from 'js-cookie'

const DATEPICKER_OPTIONS = {
  format: 'dd/mm/yyyy',
  autoclose: true,
  language: window.LANGUAGE_CODE
}

const TIMEPICKER_OPTIONS = {
    minuteStep: 30,
    snapToStep: true,
    template: false,
    showSeconds: false,
    showMeridian: false,
    defaultTime: false
}


export default class Calendar {
  constructor(selector) {
    this.$calendar = $(selector)
    this.$subnav = $('.account-navs')
    this.$dynModalContainer = $('#dyn-modal-container')
    // Modals
    this.$emptyModal = $('#empty-modal')
    this.$eventCreateModal = $('#event-create')
    // Attributes
    this.$slot = undefined
    this.$currDate = undefined
    this.$currHour = undefined
    this.$returnDate = undefined
    this.$returnHour = undefined
    // URLs config
    this.urls = {
      'unavailability-create': '/accounts/pro/calendar/offer/<id>/unavailability/create/',
      'unavailability-update': '/accounts/pro/calendar/unavailability/<id>/update/',
      'unavailability-delete': '/accounts/pro/calendar/unavailability/<id>/delete/',
      'event-create': '/accounts/pro/calendar/offer/<id>/event/create/',
      'event-update': '/accounts/pro/calendar/offer/<id>/<slot>/event/update/',
      'event-delete': '/accounts/pro/calendar/offer/<id>/<slot>/event/delete/',
    }
    // Headers
    $.ajaxSetup({
      method: 'POST',
      dataType: 'json',
      beforeSend: function(xhr, settings) {
        xhr.setRequestHeader("X-CSRFToken", Cookies.get('csrftoken'));
      }
    })
    // Init
    this.init()
  }

  init() {
    // Floatting thead for calendar
    this.$calendar.floatThead({
        top: this.$subnav.offset().top + this.$subnav.outerHeight() - $(window).scrollTop(),
        position: 'fixed'
    });
    // Init click event on badges
    this.$calendar.on("click", ".badge", (e) => this.clickOnBadge(e))
    // Init click event on in-unavailability cells
    this.$calendar.on("click", ".in-unavailability", (e) => this.openUnavailabilityUpdateForm(e))
    // Modals
    this.initEmptyModal()
    $('.modal').on('hide.bs.modal', (e) => this.onModalDismiss(e))
    $('form').each(function(){this.reset()})
  }

  _getUrl(url_name, args){
    let url = this.urls[url_name]
    for (let arg in args){
      url = url.replace('<'+arg+'>', args[arg])
    }
    return url
  }

  _getTd(elem){
    if(elem.is('td')){
      return elem
    } else {
      return elem.parent('td')
    }
  }

  _getMainElem(elem){
    // Return element containing data attrs (can be badge or td)
    if(elem.is('td') || elem.is('.badge')){
      return elem
    } else {
      return elem.parent('.badge')
    }
  }

  initEmptyModal() {
    this.$emptyModal.find('#btn-create-unavailability').click((e) => {
      this.openUnavailabilityCreateForm(e)
    })
    this.$emptyModal.find('#btn-create-event').click((e) => {
      this.openEventCreateForm(e)
    })
  }

  clickOnBadge(e) {
    let elem = this._getMainElem($(e.target))
    this.$slot = elem.data('slot')
    this.$currDate = elem.data('date')
    this.$currHour = elem.data('hour')
    if(this.$currHour != undefined){
      this.$currHour = this.$currHour.replace('H', ':')
    }
    this.$returnDate = elem.data('return-date')
    this.$returnHour = elem.data('return-hour')
    if(this.$returnHour != undefined){
      this.$returnHour = this.$returnHour.replace('H', ':')
    }
    this.$offerId = this._getTd(elem).data('offer-id')
    if(elem.hasClass('badge-danger') || elem.hasClass('badge-warning')) {
      this.openEventUpdateForm(e)
    }
    if($(e.target).hasClass('badge-success')) {
      $('#empty-modal').modal();
    }
  }

  initGenericSaveBtn(modal, url) {
    modal.find('.modal-footer .btn-pro').click((e) => {
      let btn = $(e.target)
      btn.prop('disabled', true)
      let form = modal.find('form')
       $.post(url, form.serialize())
        .done((data) => {
          location.reload()
        })
        .fail((err) => {
          let err_txt
          let form_errors = err.responseJSON.form_errors
          if(form_errors != undefined && form_errors['__all__'] != undefined) {
            err_txt = form_errors['__all__'][0]
            $('#form-errors').text(err_txt)
          }
          let formset_errors = err.responseJSON.formset_errors
          if(formset_errors != undefined && formset_errors['__all__'] != undefined) {
            err_txt = formset_errors['__all__'][0]
            $('#formset-errors').text(err_txt)
          } else {
            for(var i in formset_errors) {
              for (var f_name in formset_errors[i]) {
                err_txt = formset_errors[i][f_name][0]
                form.find('#id_lines-'+i+'-'+f_name).siblings('p').text(err_txt)
              }
            }
          }
          btn.prop('disabled', false)
        })
        return false
    })
  }

  openUnavailabilityCreateForm(e) {
    let url = this._getUrl('unavailability-create', {id: this.$offerId})
    $.get(url).done((data) => {
      this.$dynModalContainer.html(data.html)
      let modal = this.$dynModalContainer.find('.modal')
      modal.modal('show')
           .on('hide.bs.modal', (e) => this.onModalDismiss(e))
      modal.find('#id_activity').val(this.$offerId)
      modal.find('#id_start_0').val(this.$currDate)
      modal.find('#id_start_1').val('00:00')
      modal.find('#id_end_0').val(this.$currDate)
      modal.find('#id_end_1').val('23:00')
      // Datepickers
      $('#id_start_0, #id_end_0').datepicker(DATEPICKER_OPTIONS)

      // Replace Timepicker by Html5 time input
      //$('#id_start_1, #id_end_1').timepicker(TIMEPICKER_OPTIONS)
      document.getElementById('id_start_1').type = 'time';
      document.getElementById('id_end_1').type = 'time';


      // Save button
      this.initGenericSaveBtn(modal, url)
    })
  }

  openUnavailabilityUpdateForm(e) {
    let url = this._getUrl('unavailability-update', {id:$(e.target).data('id')})
    $.get(url, (data) => {
      this.$dynModalContainer.html(data.html)
      let modal = this.$dynModalContainer.find('.modal')
      modal.modal('show')
           .on('hide.bs.modal', (e) => this.onModalDismiss(e))
      // Datepickers
      $('#id_start_0, #id_end_0').datepicker(DATEPICKER_OPTIONS)
      // $('#id_start_1, #id_end_1').timepicker(TIMEPICKER_OPTIONS)
      document.getElementById('id_start_1').type = 'time';
      document.getElementById('id_end_1').type = 'time';

      // Save button
      this.initGenericSaveBtn(modal, url)
      // Delete button
      this.$dynModalContainer.find('.btn-danger').popover(
        {placement:'top', html:true}
      ).on('shown.bs.popover', () => {
        let popover = $('.popover')
        popover.find('.text-muted').click(() => {
          popover.popover('hide')
          return false
        });
        popover.find('.text-danger').click(() => {
         let del_url = this._getUrl('unavailability-delete', {id:$(e.target).data('id')})
         $.post(del_url).done(function(data) {
            location.reload();
         });
         return false
        });
      });
    });
  }

  openEventCreateForm(e) {
    let url = this._getUrl('event-create', {id: this.$offerId})
    $.get(url, (data) => {
      this.$dynModalContainer.html(data.html)
      let modal = this.$dynModalContainer.find('.modal')
      modal.modal('show')
           .on('hide.bs.modal', (e) => this.onModalDismiss(e))
      modal.find('#id_activity').val(this.$offerId)
      modal.find('#id_start_0').val(this.$currDate)
      modal.find('#id_start_1').val(this.$currHour)
      modal.find('#id_end_0').val(this.$returnDate)
      modal.find('#id_end_1').val(this.$returnHour)
      // Datepickers
      $('#id_start_0, #id_end_0').datepicker(DATEPICKER_OPTIONS)
      // $('#id_start_1, #id_end_1').timepicker(TIMEPICKER_OPTIONS)
      document.getElementById('id_start_1').type = 'time';
      document.getElementById('id_end_1').type = 'time';

      // Add line button
      modal.find('#add-line').click(() => {
        modal.find('.extra').first().removeClass('extra')
        return false;
      });
      // Save button
      this.initGenericSaveBtn(modal, url)
    })
  }


  openEventUpdateForm(e) {
    let url = this._getUrl('event-update', {id:this.$offerId, slot:this.$slot})
    $.get(url, (data) => {
      this.$dynModalContainer.html(data.html)
      let modal = this.$dynModalContainer.find('.modal')
      modal.modal('show')
        .on('hide.bs.modal', (e) => this.onModalDismiss(e))
      // Edit buttons
      this.$dynModalContainer.find('.edit').click((e) => {
        let line = $(e.target).parents('.event-line')
        line.addClass('editable')
      });
      // Add line button
      this.$dynModalContainer.find('#add-line').click(() => {
        this.$dynModalContainer.find('.extra').first().removeClass('extra')
        return false;
      });
      // Save button
      this.initGenericSaveBtn(modal, url)
      // Delete button
      this.$dynModalContainer.find('.btn-danger').popover(
        {placement:'top', html:true}
      ).on('shown.bs.popover', () => {
        let popover = $('.popover')
        popover.find('.text-muted').click(() => {
          popover.popover('hide')
          return false
        });
        popover.find('.text-danger').click(() => {
         let del_url = this._getUrl('event-delete', {id:this.$offerId, slot:this.$slot})
         $.post(del_url).done(function(data) {
            location.reload();
         });
         return false
        });
      });
    });
  }

  onModalDismiss(e) {
    let forms = $(e.target).find('form')
    if(forms.length > 0) {
      forms[0].reset()
    }
  }

}



// WEBPACK FOOTER //
// ./accounts/pro/static/js/services/calendar.js